module.exports = __webpack_public_path__ + "img/peach.ee1d540a.svg";